import myweb from './index.vue'
import routers from '@/router/router'

export const mywebNav = () => {
  // console.log(routers, 11)
  let navData = routers.filter(item => {
    if (item.name) {
      return item.name.includes('myweb')
    } else {
      // console.log('bug', item)
    }
  })
  // console.log(navData, 'sdf')

  role(navData)
  // let navs = navData
  let res = navData
  // console.log(res)
  // TODO 这里做myweb权限管理
  return res
}
const role = arr => {
  let siderList = JSON.parse(localStorage.getItem('siderList'))
  // console.log(siderList)
  arr.forEach(item => {
    // console.log(item)
    if (siderList.includes(item.mark) || !item.mark) {
      item.menuShow = true
    } else {
      item.menuShow = false
    }

    if (item.children) {
      role(item.children)
    }
  })
}
export default myweb
